import { useState } from 'react';
import dayjs from 'dayjs';

import AddImage from '../../reusable/images/add-image/add-image.component';
import Button from '../../reusable/button/button.component';
import ComponentModal from '../../reusable/component-modal/component-modal.component';
import ImageGallery from '../../reusable/images/image-gallery/image-gallery.component';
import Spinner from '../../reusable/spinner/spinner.component';

import Client from '../../../tools/client';

import {
  MainContainer,
  ContentContainer,
  Title,
  FieldLabel,
  FieldValue,
  FieldBlock,
  MetadataBox,
  RowContainer
} from './note-display.styles';

const client = new Client();

const NoteDisplay = ({ note, setShowEdit = () => {}, onRefresh = () => {} }) => {
  const [ loading, setLoading ] = useState(false);
  const [ imageFile, setImageFile ] = useState(null);
  const [ showAddImage, setShowAddImage ] = useState(false);

  const images = note.images?.map((img) => ({
    id: img.id || img.Image?.id,
    url: img.path || img.Image?.path,
    filename: img.filename || img.Image?.filename,
  })) || [];

  const addImage = async (image) => {
    if (!image) return;

    const formData = new FormData();
    formData.append('files', image);

    try {
      setLoading(true);
      await client.addNoteImage(note.id, formData);
      setImageFile(null);
      setShowAddImage(false);
      onRefresh();
    } catch (err) {
      console.error('Image upload failed:', err);
    } finally {
      setLoading(false);
    }
  };

  const deleteImage = async (imageId) => {
    setLoading(true);
    await client.deleteNoteImage(note.id, imageId);
    onRefresh();
    setLoading(false);
  };

  return (
    <MainContainer>
      <ComponentModal
        isOpen={showAddImage}
        onClose={() => setShowAddImage(false)}
        title="Add Note Image"
      >
        <AddImage
          image={imageFile}
          setImage={setImageFile}
          showSaveButton={true}
          saveImage={addImage}
        />
      </ComponentModal>

      {loading ?
        <Spinner />
      :
        <ContentContainer>
          <Title>Note Details</Title>

          <FieldBlock>
            <strong>Created:</strong> {dayjs(note.createdAt).format('MMMM D, YYYY [at] h:mm A')}
          </FieldBlock>

          <FieldBlock>
            <FieldLabel>Type:</FieldLabel>
            <FieldValue>{note.type || 'N/A'}</FieldValue>
          </FieldBlock>

          <FieldBlock>
            <FieldLabel>Visibility:</FieldLabel>
            <FieldValue>{note.isPublic ? 'Public' : 'Internal Only'}</FieldValue>
          </FieldBlock>

          <FieldBlock>
            <FieldLabel>Content:</FieldLabel>
            <FieldValue>{note.content}</FieldValue>
          </FieldBlock>

          {note.metadata && (
            <FieldBlock>
              <FieldLabel>Metadata:</FieldLabel>
              <MetadataBox>
                {typeof note.metadata === 'string'
                  ? note.metadata
                  : JSON.stringify(note.metadata, null, 2)}
              </MetadataBox>
            </FieldBlock>
          )}

          {images.length > 0 && (
            <FieldBlock>
              <FieldLabel>Attached Image{images.length > 1 ? 's' : ''}:</FieldLabel>
              <ImageGallery images={images} onDelete={deleteImage} />
            </FieldBlock>
          )}
          <RowContainer>
            <Button onClick={() => setShowAddImage(true)}>Add Image</Button>
            <Button onClick={setShowEdit}>Update</Button>
          </RowContainer>
        </ContentContainer>
        }
    </MainContainer>
  );
};

export default NoteDisplay;